import GemeinsamHelfenLogo from 'assets/images/logos/gemeinsam_helfen_de.svg'
import NussbaumLogo from 'assets/images/logos/nussbaum.svg'
import WirWunderLogo from 'assets/images/logos/wirwunder_logo.svg'
import WirWunderSparkasse from 'assets/images/logos/wirwunder_sparkasse.svg'
import classNames from 'classnames'
import React, { type ReactNode } from 'react'
import { cookieValueForProject, hasWirWunderCookie } from '../../helpers/wirwunder_helpers'
import styles from './client_header.module.css'
import { ClientHeaderProps } from './type'

const NUSSBAUM_URL = 'https://www.gemeinsamhelfen.de/'

const WirWunderHeader = ({ wirWunderWhiteLogo }: { wirWunderWhiteLogo?: string }) => {
  return (
    <div className={classNames(styles.projectsWirwunderHeader, styles.container)}>
      <img src={WirWunderLogo} className={styles.logoWirwunder} alt="WirWunder Logo" width={128} />
      <img
        src={wirWunderWhiteLogo ?? WirWunderSparkasse}
        className={styles.logoSparkasse}
        alt="Sparkasse Logo"
        width={122}
        height={70}
      />
    </div>
  )
}

const NussbaumHeader = () => {
  return (
    <div className={classNames(styles.projectsNussbaumHeader, styles.container)}>
      <img src={GemeinsamHelfenLogo} className={styles.logoGemeinsamHelfen} alt="gemeinsamhelfen.de Logo" width={128} />
      <img src={NussbaumLogo} className={styles.logoNussbaum} alt="Nussbaum Logo" width={122} height={70} />
    </div>
  )
}

function BannerLink({ href, children }: { href?: string; children: ReactNode }) {
  if (!children) return null
  if (!href) return <>{children}</>
  return (
    <a href={href} className={styles.link} target="_blank" rel="noreferrer">
      {children}
    </a>
  )
}

export const ClientHeader = ({ clientUrl, projectId, wirWunderWhiteLogoUrl }: ClientHeaderProps) => {
  const cookieValue = cookieValueForProject(projectId)
  const hasWwCookie = hasWirWunderCookie(projectId)
  if (hasWwCookie) {
    return (
      <BannerLink href={clientUrl}>
        <WirWunderHeader wirWunderWhiteLogo={wirWunderWhiteLogoUrl} />
      </BannerLink>
    )
  }
  if (cookieValue === 'nussbaum') {
    return (
      <BannerLink href={NUSSBAUM_URL}>
        <NussbaumHeader />
      </BannerLink>
    )
  }
  return null
}
